import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { useStorage } from "@vueuse/core";

type ExecutionTarget = "web" | "capacitor";

type debugServerSettings = {
	AccessNumber: number;
	ServerType: "mqtt";
	connected: boolean;
};

export const useDeviceStore = defineStore("deviceStore", () => {
	const desativarTeclado = ref<boolean>(false);

	async function setDesativarTeclado(value: boolean) {
		desativarTeclado.value = value;
		// await Keyboard.removeAllListeners();
	}

	const serverIP = ref<string>("");
	function setServerIP(ip: string) {
		serverIP.value = ip;
	}

	const serverPort = ref<number>(0);
	function setServerPort(port: number) {
		serverPort.value = port;
	}

	const doPing = ref<boolean>(false);

	function setDoPing(status: boolean) {
		doPing.value = status;
	}

	const ping = ref<number>(0);

	function setPing(pingValue: number) {
		ping.value = pingValue;
	}

	const platform = ref<"web" | "ios" | "android">();

	function setPlatform(value: "web" | "ios" | "android") {
		platform.value = value;
	}

	const executionTarget = ref<ExecutionTarget>("web");

	const isWeb = computed(() => executionTarget.value === "web");

	const isCapacitor = computed(() => executionTarget.value === "capacitor");

	const isNative = ref<boolean>(false);

	function setIsNative(value: boolean) {
		isNative.value = value;
		executionTarget.value = value ? "capacitor" : "web";
	}

	function setExecutionTarget(value: ExecutionTarget) {
		executionTarget.value = value;
		isNative.value = value === "capacitor";
	}

	const debugSettings = ref<debugServerSettings>({
		AccessNumber: 0,
		ServerType: "mqtt",
		connected: false,
	});

	function setDebugSettings(value: debugServerSettings) {
		debugSettings.value = value;
	}

	const debugEnabled = ref<boolean>(false);

	const deviceName = useStorage("deviceName", "", localStorage);

	function setDeviceName(value: string) {
		deviceName.value = value;
	}

	function setDebugEnabled(value: boolean) {
		debugEnabled.value = value;
	}

	const enableAnimations = ref<boolean>(true);

	function setAnimationEnabledStatus(value: boolean) {
		enableAnimations.value = value;
	}

	const isMobile = ref(false);
	function setIsMobile(value: boolean) {
		isMobile.value = value;
	}

	return {
		desativarTeclado,
		setDesativarTeclado,
		serverIP,
		setServerIP,
		serverPort,
		setServerPort,
		ping,
		setPing,
		platform,
		setPlatform,
		executionTarget,
		isWeb,
		isCapacitor,
		isNative,
		setIsNative,
		setExecutionTarget,
		debugSettings,
		setDebugSettings,
		enableAnimations,
		setAnimationEnabledStatus,
		debugEnabled,
		setDebugEnabled,
		deviceName,
		setDeviceName,
		isMobile,
		setIsMobile,
		doPing,
		setDoPing
	}
}, {
	persist: true
});
